import { render, staticRenderFns } from "./NsVTextField.vue?vue&type=template&id=2a6056f4&scoped=true&"
import script from "./NsVTextField.vue?vue&type=script&lang=js&"
export * from "./NsVTextField.vue?vue&type=script&lang=js&"
import style0 from "./NsVTextField.vue?vue&type=style&index=0&id=2a6056f4&scoped=true&lang=scss&"
import style1 from "./NsVTextField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6056f4",
  null
  
)

export default component.exports